import { render, staticRenderFns } from "./StockQualityHoldDialog.vue?vue&type=template&id=c8101bce"
import script from "./StockQualityHoldDialog.vue?vue&type=script&lang=js"
export * from "./StockQualityHoldDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports